import React, { useState, useEffect } from "react";
import { ArrowLeftCircleIcon, ArrowRightCircleIcon } from "lucide-react";
import avatar from "../../assets/image.png";
import { webSiteReviewsService } from "../../services/webReviewServices.js";

export default function CarrosselAvaliacoes() {
  const [avaliacoes, setAvaliacoes] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  // Buscar avaliações da API
  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await webSiteReviewsService.getAllReviews();
        const avaliacoes = response.map((avaliacao) => ({
          id: avaliacao.id,
          user: {
            id: avaliacao.user_id,
            name: avaliacao.user_name,
          },
          rating: avaliacao.rating,
          comment: avaliacao.comment,
        }));
        setAvaliacoes(avaliacoes);
        console.log("response", response);
        console.log("avaliacoes", avaliacoes);
      } catch (error) {
        console.error("Erro ao buscar avaliações:", error);
      }
    };

    fetchReviews();
  }, []);

  // Responsividade
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getVisibleIndices = () => {
    if (isMobile) {
      return [currentIndex % avaliacoes.length];
    } else {
      return [
        currentIndex % avaliacoes.length,
        (currentIndex + 1) % avaliacoes.length,
        (currentIndex + 2) % avaliacoes.length,
      ];
    }
  };

  const proximaAvaliacao = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex + (isMobile ? 1 : 3)) % avaliacoes.length
    );
  };

  const avaliacaoAnterior = () => {
    setCurrentIndex(
      (prevIndex) =>
        (prevIndex - (isMobile ? 1 : 3) + avaliacoes.length) % avaliacoes.length
    );
  };

  const renderEstrelas = (quantidade) => {
    return Array(5)
      .fill(0)
      .map((_, i) => (
        <span
          key={i}
          className={`text-2xl ${
            i < quantidade ? "text-yellow-400" : "text-gray-300"
          }`}>
          ★
        </span>
      ));
  };

  if (avaliacoes.length === 0) {
    return;
  }

  return (
    <div className="w-full mx-auto py-12 px-4">
      <h2 className="text-3xl font-bold text-center mb-12">
        O que nossos clientes dizem
      </h2>

      <div className="relative">
        <div className="overflow-hidden h-full">
          <div className="grid grid-cols-1 m-3 mt-4 md:grid-cols-3 gap-4">
            {getVisibleIndices().map((index) => {
              const avaliacao = avaliacoes[index];
              return (
                <div
                  key={avaliacao.id}
                  className="w-full bg-white rounded-lg shadow-lg p-6 md:p-8">
                  <div className="flex flex-col items-center text-center">
                    <div className="h-20 w-20 mb-4 rounded-full bg-gray-200 overflow-hidden">
                      <img
                        src={avatar}
                        alt={avaliacao.user.name}
                        className="h-full w-full object-contain"
                      />
                    </div>
                    <div className="flex mb-4">
                      {renderEstrelas(avaliacao.rating)}
                    </div>
                    <blockquote className="text-lg mb-6 italic">
                      "{avaliacao.comment}"
                    </blockquote>
                    <div>
                      <p className="font-semibold">{avaliacao.user.name}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="flex justify-center mt-8 gap-2">
          <button
            onClick={avaliacaoAnterior}
            className="p-2 rounded-md border-gray-300 hover:bg-gray-100"
            aria-label="Avaliações anteriores">
            <ArrowLeftCircleIcon className="h-10 w-10 text-green-600" />
          </button>

          {Array(Math.ceil(avaliacoes.length / (isMobile ? 1 : 3)))
            .fill(0)
            .map((_, index) => {
              const pageIndex = index * (isMobile ? 1 : 3);
              return (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(pageIndex)}
                  className={`h-3 w-3 rounded-full p-0 ${
                    currentIndex === pageIndex ? "bg-green-600" : "bg-gray-300"
                  }`}
                  aria-label={`Ir para página ${index + 1}`}>
                  <span className="sr-only">Página {index + 1}</span>
                </button>
              );
            })}

          <button
            onClick={proximaAvaliacao}
            className="p-2 rounded-md border-gray-300 hover:bg-gray-100"
            aria-label="Próximas avaliações">
            <ArrowRightCircleIcon className="h-10 w-10 text-green-600" />
          </button>
        </div>
      </div>
    </div>
  );
}
